(() => {
  function readProducts(node) {
    return JSON.parse(node.content ? node.content.textContent : node.textContent);
  }
  function selectProducts(products, { latest = false, previous = [], random = Math.random, count = 3 } = {}) {
    const seen = new Set();
    const pool = products.filter(p => p.image && (latest || p.available) && !seen.has(String(p.id)) && seen.add(String(p.id)));
    if (latest) return pool.slice(0, count);
    const shuffled = [...pool];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    const picked = shuffled.slice(0, count);
    const previousIds = new Set(previous.map(String));
    if (pool.length > count && picked.every(p => previousIds.has(String(p.id)))) {
      const other = shuffled.find(p => !previousIds.has(String(p.id)));
      if (other) picked[0] = other;
    }
    return picked;
  }
  function randomPage(count, previous, random = Math.random) {
    const pages = Math.max(1, Math.ceil(count / 50));
    let page = Math.floor(random() * pages) + 1;
    if (pages > 1 && page === previous) page = page % pages + 1;
    return page;
  }
  function worldProducts(products, key) {
    if (key !== 'latest') products = products.filter(p => !/\b(?:baby carrier|hero carrier)\b/i.test(p.title));
    const marvel = /\b(?:marvel|spider[- ]?man|iron[- ]?man|thanos|captain america|capitan america|she-hulk|daredevil|black panther|vision|guardians of the galaxy|punisher|wolverine|fantastic four|moon\s?knight|deadpool|green goblin)\b/i;
    const dc = /\b(?:dc direct|dc comics?|dc multiverse|batman|joker|wonder woman|flash|bane|aquaman|superman|green lantern|martian manhunter|shazam|batgirl|robin|nightwing|doctor fate|atom|plastic man|batwoman|supergirl|suicide squad|harley qu(?:ee|i)n|swamp thing|sandman|green arrow|two-face)\b/i;
    if (key === 'marvel') return products.filter(p => marvel.test(p.title));
    if (key === 'dc-comics') return products.filter(p => dc.test(p.title) && !/\b(?:gi joe|g\.i\. joe|one piece|star wars)\b/i.test(p.title));
    return products;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { selectProducts, randomPage, worldProducts, readProducts };
  if (typeof customElements === 'undefined' || customElements.get('mmlc-showcase')) return;
  class MmlcShowcase extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.panels = [...this.querySelectorAll('[data-showcase-panel]')];
      const latest = this.panels.find(p => p.hasAttribute('data-latest'));
      const worlds = this.panels.filter(p => p !== latest);
      for (let i = worlds.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [worlds[i],worlds[j]] = [worlds[j],worlds[i]]; }
      this.panels = [latest, ...worlds.slice(0,9)].filter(Boolean);
      this.querySelectorAll('[data-showcase-panel]').forEach(p => {p.hidden=true;});
      this.panels.forEach(p => this.append(p));
      this.panels[0].hidden=false;
      this.tabs = this.querySelector('[data-tabs]');
      this.announce = this.querySelector('[data-announce]');
      this.abort = new AbortController();
      this.requests = new Set();
      this.products = new Map();
      this.progress = this.querySelector('.studio-showcase__progress span');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const signal = this.abort.signal;
      this.mobile = matchMedia('(max-width: 749px)');
      this.paused = this.motion.matches || this.mobile.matches;
      this.mobile.addEventListener('change', () => { if (this.mobile.matches) this.paused = true; this.schedule(); }, {signal});
      this.inView = false;
      this.playButton = this.querySelector('[data-autoplay]');
      this.playButton?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.schedule();
      }, {signal});
      this.addEventListener('pointerenter', event => { if(event.pointerType === 'mouse') { this.hovering = true; this.schedule(); } }, {signal});
      this.addEventListener('pointerleave', () => { this.hovering = false; this.schedule(); }, {signal});
      this.addEventListener('focusin', () => this.schedule(), {signal});
      this.addEventListener('focusout', () => { clearTimeout(this.focusTimer); this.focusTimer = setTimeout(() => this.schedule(), 0); }, {signal});
      this.addEventListener('touchstart', event => { if (event.target.closest('[data-autoplay]')) return; this.paused = true; this.schedule(); }, {passive:true,signal});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.schedule(); }, {signal});
      this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); }, {threshold:.25});
      this.observer.observe(this);
      this.panels.forEach((panel, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = panel.dataset.label;
        button.dataset.index = index;
        button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', () => this.activate(index, true), { signal });
        this.tabs.append(button);
      });
      this.buttons = [...this.tabs.children];
      this.tabs.hidden = false;
      this.querySelector('[data-controls]').hidden = false;
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => this.activate(this.index + Number(button.dataset.direction), true), { signal }));
      this.tabs.addEventListener('keydown', event => {
        let index = this.index;
        if (event.key === 'ArrowRight') index++;
        else if (event.key === 'ArrowLeft') index--;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.panels.length - 1;
        else return;
        event.preventDefault();
        this.activate(index, true);
        this.buttons[this.index].focus({ preventScroll: true });
      }, { signal });
      this.addEventListener('pointermove', event => {
        if (event.pointerType !== 'mouse' || this.motion.matches) return;
        const card = event.target.closest('.studio-deck-card');
        if (!card) return;
        this.pointer = {card,x:event.clientX,y:event.clientY};
        if (this.pointerFrame) return;
        this.pointerFrame = requestAnimationFrame(() => {
          this.pointerFrame = 0;
          const point = this.pointer;
          if (!point || !point.card.isConnected || this.motion.matches) return;
          const rect = point.card.getBoundingClientRect();
          point.card.style.setProperty('--tilt-x', `${-(point.y - rect.top - rect.height / 2) / rect.height * 7}deg`);
          point.card.style.setProperty('--tilt-y', `${(point.x - rect.left - rect.width / 2) / rect.width * 7}deg`);
        });
      }, { passive: true, signal });
      this.addEventListener('pointerout', event => {
        const card = event.target.closest('.studio-deck-card');
        if (card && !card.contains(event.relatedTarget)) {
          if (this.pointer?.card === card) this.pointer = null;
          card.style.removeProperty('--tilt-x');
          card.style.removeProperty('--tilt-y');
        }
      }, { signal });
      this.activate(Math.max(0, this.panels.findIndex(p => !p.hidden)), false);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.focusTimer);
      clearTimeout(this.prefetchTimer);
      cancelAnimationFrame(this.pointerFrame);
      this.pointerFrame = 0;
      this.pointer = null;
      this.progressAnimation?.cancel();
      this.observer?.disconnect();
      this.abort?.abort();
      this.requests?.forEach(controller => controller.abort());
      this.panels?.forEach(panel => {
        delete panel.dataset.loading;
        delete panel.dataset.loaded;
        delete panel.dataset.rendered;
        panel.removeAttribute('aria-busy');
      });
      this.tabs?.replaceChildren();
      this.ready = false;
    }
    activate(index, announce) {
      if (announce) this.paused = true;
      this.index = (index + this.panels.length) % this.panels.length;
      this.panels.forEach((panel, i) => { panel.hidden = i !== this.index; });
      this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.index)));
      this.querySelector('[data-counter]').textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(this.panels.length).padStart(2, '0')}`;
      const panel = this.panels[this.index];
      const button = this.buttons[this.index];
      this.dataset.universe = panel.dataset.key;
      if (!panel.dataset.rendered) {
        const cached = this.products.get(panel);
        if (cached) this.render(panel, cached);
        else if (!panel.hasAttribute('data-latest') && !panel.querySelector('.studio-deck-card')) {
          this.render(panel, selectProducts(worldProducts(readProducts(panel.querySelector('[data-pool]')), panel.dataset.key), {count:Number(panel.dataset.size || 3)}));
        }
      }
      if (announce) {
        this.announce.textContent = panel.dataset.label;
        this.tabs.scrollTo({ left: button.offsetLeft - this.tabs.offsetLeft - 12, behavior: this.motion.matches ? 'instant' : 'smooth' });
      }
      this.load(panel);
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      clearTimeout(this.prefetchTimer);
      const reading = this.contains(document.activeElement) && document.activeElement !== this.playButton;
      const playing = !this.paused && !this.motion.matches && this.inView && !this.hovering && !reading && !document.hidden;
      this.dataset.playing = String(playing);
      if (this.playButton) {
        this.playButton.setAttribute('aria-label', this.paused || this.motion.matches ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.playButton.firstElementChild.textContent = this.paused || this.motion.matches ? '▷' : 'Ⅱ';
      }
      this.progressAnimation?.cancel();
      if (playing) {
        this.progressAnimation = this.progress?.animate([{transform:'scaleX(0)'},{transform:'scaleX(1)'}], {duration:8000,fill:'forwards'});
        this.prefetchTimer = setTimeout(() => this.load(this.panels[(this.index + 1) % this.panels.length]), 2000);
        this.timer = setTimeout(() => this.activate(this.index + 1, false), 8000);
      }
    }
    memory(key) {
      try { return JSON.parse(sessionStorage.getItem(`mmlc-showcase-v1:${key}`) || '{}'); }
      catch { return {}; }
    }
    async feed(panel, page) {
      if (panel.hasAttribute('data-latest') && page === 1 && window.mmlcLatestFeed) {
        const pending = window.mmlcLatestFeed;
        window.mmlcLatestFeed = null;
        const html = await pending;
        if (html) {
          const template = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-showcase-feed]');
          if (template) return readProducts(template);
        }
      }
      const url = new URL(panel.dataset.url, location.origin);
      if (url.origin !== location.origin) throw new Error('Invalid collection origin');
      url.searchParams.set('section_id', 'mmlc-showcase-feed');
      url.searchParams.set('page', String(page));
      if (panel.hasAttribute('data-latest')) url.searchParams.set('sort_by', 'created-descending');
      const controller = new AbortController();
      this.requests.add(controller);
      const timeout = setTimeout(() => controller.abort(), 6500);
      try {
        const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection unavailable');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const template = document.querySelector('[data-showcase-feed]');
        if (!template) throw new Error('Missing collection feed');
        return readProducts(template);
      } finally {
        clearTimeout(timeout);
        this.requests.delete(controller);
      }
    }
    async load(panel) {
      if (panel.dataset.loaded || panel.dataset.loading) return;
      if (panel.hasAttribute('data-server-rendered')) {
        try {
          const initial = selectProducts(readProducts(panel.querySelector('[data-pool]')), { latest: true, count: Number(panel.dataset.size || 5) });
          const cards = [...panel.querySelectorAll('[data-product-id]')];
          if (cards.length === initial.length && cards.every((card, index) => String(card.dataset.productId) === String(initial[index].id))) {
            this.products.set(panel, initial);
            panel.dataset.loaded = 'true';
            panel.dataset.rendered = 'true';
            panel.querySelector('[data-empty]').hidden = initial.length > 0;
            return;
          }
        } catch {}
      }
      panel.dataset.loading = 'true';
      panel.setAttribute('aria-busy', 'true');
      const latest = panel.hasAttribute('data-latest');
      const previous = this.memory(panel.dataset.key);
      let page = latest ? 1 : randomPage(Number(panel.dataset.count), previous.page);
      let products = [];
      let success = false;
      try {
        let result = await this.feed(panel, page);
        products = worldProducts(result.products, panel.dataset.key);
        if (!latest && page !== 1 && (products.filter(p => p.available).length < Number(panel.dataset.size || 3) || page > result.pages)) {
          page = 1;
          result = await this.feed(panel, page);
          products = [...products, ...worldProducts(result.products, panel.dataset.key)];
        }
        success = true;
      } catch {
        if (!latest && !products.length) products = worldProducts(readProducts(panel.querySelector('[data-pool]')), panel.dataset.key);
      }
      if (!this.isConnected) return;
      const picked = selectProducts(products, { latest, previous: previous.ids || [], count: Number(panel.dataset.size || 3) });
      this.products.set(panel, picked);
      if (!panel.hidden) this.render(panel, picked);
      else delete panel.dataset.rendered;
      const empty = panel.querySelector('[data-empty]');
      empty.hidden = picked.length > 0;
      if (!success && latest) empty.textContent = this.dataset.error;
      delete panel.dataset.loading;
      panel.removeAttribute('aria-busy');
      panel.dataset.loaded = 'true';
      if (!latest && picked.length) {
        try { sessionStorage.setItem(`mmlc-showcase-v1:${panel.dataset.key}`, JSON.stringify({ ids: picked.map(p => p.id), page })); } catch {}
      }
    }
    render(panel, products) {
      const cards = panel.querySelector('[data-cards]');
      const fragment = document.createDocumentFragment();
      cards.dataset.count = products.length;
      for (const product of products) {
        const destination = new URL(product.url, location.origin);
        if (destination.origin !== location.origin) continue;
        const card = document.createElement('a');
        card.className = 'studio-deck-card';
        card.href = destination.pathname + destination.search;
        card.dataset.productId = product.id;
        card.setAttribute('aria-label', `${product.title} — ${product.price}`);
        const photo = document.createElement('span');
        photo.className = 'studio-deck-card__photo';
        const image = document.createElement('img');
        image.alt = '';
        image.width = product.width || 540;
        image.height = product.height || 640;
        image.decoding = 'async';
        image.loading = products.indexOf(product) < 2 ? 'eager' : 'lazy';
        if (panel.hasAttribute('data-latest') && products.indexOf(product) === 0) image.fetchPriority = 'high';
        const smallWidth = product.smallWidth || 280;
        const imageWidth = product.width || 540;
        const sources = new Map([[smallWidth, product.small], [imageWidth, product.image]]);
        if (product.medium && product.mediumWidth > smallWidth && product.mediumWidth < imageWidth) sources.set(product.mediumWidth, product.medium);
        image.srcset = [...sources].sort((a, b) => a[0] - b[0]).map(([width, url]) => `${url} ${width}w`).join(', ');
        const ratio = image.width / image.height;
        image.sizes = `(max-width: 749px) min(70vw, 280px, ${Math.ceil(ratio * 150)}px), min(220px, ${Math.ceil(ratio * 220)}px)`;
        image.src = product.image;
        photo.append(image);
        const info = document.createElement('span');
        info.className = 'studio-deck-card__info';
        const name = document.createElement('span');
        name.className = 'studio-deck-card__name';
        name.textContent = product.title;
        const price = document.createElement('span');
        price.className = 'studio-deck-card__price';
        price.textContent = product.price;
        const arrow = document.createElement('span');
        arrow.textContent = '↗';
        arrow.setAttribute('aria-hidden', 'true');
        price.append(arrow);
        info.append(name, price);
        card.append(photo, info);
        fragment.append(card);
      }
      cards.replaceChildren(fragment);
      cards.scrollTo({left: 0, behavior: 'instant'});
      panel.dataset.rendered = 'true';
    }
  }
  customElements.define('mmlc-showcase', MmlcShowcase);
})();

